<template>
  <vx-card no-shadow>
    <div class="vx-row mb-6">
      <div class="vx-col sm:w-2/5 w-full">
        <h2>Danger Zone</h2>
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>{{ deleteText }} campaign</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-button
          color="danger"
          v-if="canArchiveOrCancel && hasPermissionForActiveVenue('vp.vp.venuecampaigns.edit')"
          @click="confirmDelete"
          class="ml-auto mt-2"
          >{{ deleteText }} Campaign</vs-button
        >
        <h5 class="my-5" v-if="!canArchiveOrCancel">
          <b>Cannot modify campaign when it has status {{ statusObject(venueCampaign.status).text }}.</b>
        </h5>
      </div>
    </div>
  </vx-card>
</template>

<script>
import campaignMixin from "@/views/mixins/campaignMixin";

export default {
  components: {},
  mixins: [campaignMixin],
  props: ["venueCampaign"],
  methods: {
    confirmDelete() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: `Are you sure you want to ${this.deleteText} this Campaign?`,
        accept: this.deleteCampaign,
      });
    },
    async deleteCampaign() {
      await this.$store.dispatch("venueCampaigns/delete", {
        venueCampaignId: this.venueCampaign.id,
        byHQ: false,
      });
      this.$vs.notify({
        color: "green",
        title: "Success",
        text: `${this.deleteText} campaign was successful`,
      });
      this.$router.go(-1);
      window.location.reload();
    },
  },
  computed: {
    deleteText() {
      return this.venueCampaign.status == "ReadyToFillOut" ? "Archive" : "Cancel";
    },
    canArchiveOrCancel() {
      return (
        this.venueCampaign.status != "Archived" &&
        this.venueCampaign.status != "Cancelled" &&
        this.venueCampaign.status != "Sent"
      );
    },
  },
};
</script>